import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Icon,
} from "@aws-amplify/ui-react";
import "./Clienti.css";
import { BsSortDown, BsSortUp } from "react-icons/bs";
import { formatValue, getLabel } from "./config";


const ClientiTable = (props) => {
  return (
    <Table caption="" highlightOnHover={true}>
        <TableHead>
        <TableRow>
            {
            props.columns.map(c => 
                <TableCell as="th" key={c}>
                <Icon 
                    as={props.order === 'asc' ? BsSortUp : BsSortDown} 
                    style={{fontSize: "24", marginTop: "7px"}}
                    color={props.sortKey === c ? '#000000' : '#d3d3d3'}
                    onClick={() => props.onUpdateOrder(c)}
                ></Icon>
                {getLabel(c) ?? '-'}
                </TableCell>
            )
            }
        </TableRow>
        </TableHead>
        <TableBody>
            {props.clienti?.map((item) => { return (
            <TableRow 
                key={item.ID}
                onClick={() => props.onClickCliente(item.ID)} 
                style={{"cursor":"pointer"}}
            >
                {
                props.columns.map(c => { return (
                    <TableCell>{formatValue(item[c], c)}</TableCell>
                ) })
                }
            </TableRow>)
            })}
        </TableBody>
    </Table>
  );
};

export default ClientiTable;
